import axios from 'axios';

// Crear instancia de axios con configuración base
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',  // Mantenemos la variable de ambiente
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Agregamos logs detallados para debug
instance.interceptors.request.use(
  config => {
    // Logs detallados
    console.log('Request Config:', {
      method: config.method,
      baseURL: config.baseURL,
      url: config.url,
      fullUrl: `${config.baseURL}${config.url}`,
      headers: config.headers,
      data: config.data
    });

    // Si es una petición multipart/form-data, no establecer Content-Type
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  error => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Interceptor para respuestas con más detalles
instance.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      console.error('Network Error:', {
        message: error.message,
        code: error.code,
        config: error.config
      });
    } else {
      console.error('Response Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    }
    return Promise.reject(error);
  }
);

export default instance;